import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-online-fees-payment',
  templateUrl: './online-fees-payment.component.html',
  styleUrls: ['./online-fees-payment.component.scss']
})
export class OnlineFeesPaymentComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  

  ngOnInit(): void {
  }

}
